"use strict";

import {onFind} from "@elements/init-modules-in-scope";
import {hasClass, removeClass, addClass, on, off, closest, findAll, findAllIn, findIn, trigger, is} from "@elements/dom-utils";
import asyncAppend from "@elements/async-append";
import fetch from '@elements/fetch';
import 'url-search-params-polyfill';
import {activateScrollLock, deactivateScrollLock} from "@elements/scroll-lock";
import formDataEntries from 'form-data-entries';
import {getMap} from './ajax-form-map';
import {getApi} from "@elements/google-map";

export function init () {
    onFind('.js-filter-bar__form', function (filterBar) {
        on('dropdown.change', function () {
            reloadFilter(filterBar);
        }, filterBar);

        on('change', function () {
            reloadFilter(filterBar);
        }, filterBar);

        on('reset.ajax-form', function () {
            reloadFilter(filterBar);
        }, closest('.js-ajax-form-map', filterBar));
    });

    onFind('.js-filter-bar__toggle', function ($toggleButton) {
        on('click', function () {
            let $parent = closest('.js-filter-bar', $toggleButton);

            if (hasClass('is-open', $parent)) {
                removeClass('is-open', $parent);

                deactivateScrollLock();
            } else {
                activateScrollLock();
                addClass('is-open', $parent);
            }

        }, $toggleButton);
    });

    onFind('.js-filter-bar__toggle--new', function ($toggleButton) {
        on('click', function () {
            let $parent = closest('.js-filter-bar', $toggleButton);

            if (hasClass('is-open', $parent)) {
                removeClass('is-open', $parent);

                deactivateScrollLock();
            } else {
                activateScrollLock();
                addClass('is-open', $parent);
            }

        }, $toggleButton);
    });

    onFind('.js-filter-bar__ajax-form', function (form) {
        if(matchMedia('(min-width: 768px)').matches){
            on('dropdown.change', function () {
                submitAjaxForm(form);
            }, form);

            on('change', function () {
                submitAjaxForm(form);
            }, form);
        }
    });
}

function submitAjaxForm(form) {

    let url = form.getAttribute('data-action');
    let formEntries = getFormDataEntries([form]);
    let params = new URLSearchParams(formEntries);
    let ajaxForm = findIn('.js-ajax-form-map', document);
    let results = findAllIn('.js-ajax-form-map__result', ajaxForm);
    let targetsByResultId = {};

    results.forEach((element) => {
        let resultId = element.dataset.resultId || 'default';
        if (targetsByResultId[resultId]) {
            targetsByResultId[resultId] = [...targetsByResultId[resultId], element];
        } else {
            targetsByResultId[resultId] = [element];
        }
    });

    let map = getMap();
    console.log(map);
    let canvas = findIn('.js-ajax-form-map__map__canvas', ajaxForm);
    console.log(canvas);

    url = new URL(location.href);
    url.searchParams.delete('page');

    url = addSearchParamsToUrl(url, params);

    history.replaceState(history.state, document.title,  url);

    let request = fetch(url, {
        body: new URLSearchParams(params)
    });

    asyncAppend({
        target: targetsByResultId,
        loading: findAll('.js-ajax-form-map__loading'),

    // }, fetch(url, {body: params}));
    }, request);

    console.log("url body params", fetch(url, {body: params}));
    console.log("request", request);

    getApi(canvas).then((api) => {
        fetchPois(api);
    })

    async function fetchPois(api) {
        if(!api){
            api = await getApi(canvas);
        }

        fetch(map.element.dataset.formMapUrl, {
            method: 'GET',
            headers: {
                ajax: 1 // add ajax header to differentiate between and ajax requests and page request.
                // If this header is not set, browser back could lead the browser to use the cached result of this request as page response.
            },
            body: new URLSearchParams(formEntries)
        }).then((res) => {
            return res.json()
        }).then((res) => {
            if (res.success) {
                api.setMarker(res.pois);
                api.centerMap();
            }
        }).catch((error) => {
            console.error("loading data-form-map-url failed:" + error);
        });
    }
}



function reloadFilter(filterBar) {
    let url = filterBar.getAttribute('data-filter-action');
    let formEntries = getFormDataEntries([filterBar]);
    let params = new URLSearchParams(formEntries);

    asyncAppend({
        target: findAll('.js-filter-bar__content'),
        loading: findAll('.js-filter-bar__loading')
    }, fetch(url, {body: params}));
}

function getFormDataEntries(forms) {
    let formDataArray = [];

    forms.map(form => {
        // unchecked checkboxes and radios needs to be added manually to formDataArray
        let selectors = findAllIn('input[type="radio"], input[type="checkbox"]', form);
        let selectorNames = [];

        selectors.map(function(selector) {
            selectorNames.push(selector.name);
        });

        for (let pair of formDataEntries(form)) {
            formDataArray.push(pair);
        }

        let existingNames = formDataArray.map(entry => entry[0]);
        selectorNames = [...new Set(selectorNames)];

        selectorNames.forEach(function (name) {
            let newEntry = [name, ""];
            if(!existingNames.includes(name)) {
                formDataArray.push(newEntry);
            } else {
                formDataArray.filter(item => item !== newEntry);
            }
        });
    });

    return formDataArray;
}

function addSearchParamsToUrl(url, searchParams) {
    url = new URL(url, location.origin);

    let searchParamsArray = Array.from(searchParams);
    console.log("url", url);
    console.log("params array", searchParamsArray);
    searchParamsArray.forEach(([name]) => url.searchParams.delete(name));
    searchParamsArray.forEach(([name, value]) => url.searchParams.append(name, value));

    return url;
}